import * as actionType from "./constants";

const initialState = {
    getMasterCapitalTypeSettingsDataResponse: {},
    getMasterCapitalTypeByIdResponse: {},
    updateMasterCapitalTypeResponse: {},
    addMasterCapitalTypeResponse: {},
    deleteMasterCapitalTypeResponse: {},
    getListForCommonFilterResponse:{},
    getAllMasterCapitalTypeLogsResponse: {},
    restoreSettingsLogResponse: {},
    deleteSettingsLogResponse: {},
    mastercapitaltypeExportResponse:{},
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters:null,
            list:null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams:{
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        },
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPDATE_MASTER_CAPITAL_TYPE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_MASTER_CAPITAL_TYPE_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_SUCCESS:
            return {
                ...state,
                getListForCommonFilterResponse: { success: true, ...action.response }
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_FAILURE:
            return {
                ...state,
                getListForCommonFilterResponse: { success: false, ...action.error }
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_SETTINGS_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_SETTINGS_DATA_SUCCESS:
            return {
                ...state,
                getMasterCapitalTypeSettingsDataResponse: { success: true, ...action.response }
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_SETTINGS_DATA_FAILURE:
            return {
                ...state,
                getMasterCapitalTypeSettingsDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_BY_ID_REQUEST:
            return {
                ...state
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_BY_ID_SUCCESS:
            return {
                ...state,
                getMasterCapitalTypeByIdResponse: { success: true, ...action.response }
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_BY_ID_FAILURE:
            return {
                ...state,
                getMasterCapitalTypeByIdResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_MASTER_CAPITAL_TYPE_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_MASTER_CAPITAL_TYPE_SUCCESS:
            return {
                ...state,
                updateMasterCapitalTypeResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_MASTER_CAPITAL_TYPE_FAILURE:
            return {
                ...state,
                updateMasterCapitalTypeResponse: { success: false, ...action.error }
            };
        case actionType.ADD_MASTER_CAPITAL_TYPE_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_MASTER_CAPITAL_TYPE_SUCCESS:
            return {
                ...state,
                addMasterCapitalTypeResponse: { success: true, ...action.response }
            };
        case actionType.ADD_MASTER_CAPITAL_TYPE_FAILURE:
            return {
                ...state,
                addMasterCapitalTypeResponse: { success: false, ...action.error }
            };
        case actionType.DELETE_MASTER_CAPITAL_TYPE_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_MASTER_CAPITAL_TYPE_SUCCESS:
            return {
                ...state,
                deleteMasterCapitalTypeResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_MASTER_CAPITAL_TYPE_FAILURE:
            return {
                ...state,
                deleteMasterCapitalTypeResponse: { success: false, ...action.error }
            };
        case actionType.GET_ALL_MASTER_CAPITAL_TYPE_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.GET_ALL_MASTER_CAPITAL_TYPE_LOG_SUCCESS:
            return {
                ...state,
                getAllMasterCapitalTypeLogsResponse: { success: true, ...action.response }
            };
        case actionType.GET_ALL_MASTER_CAPITAL_TYPE_LOG_FAILURE:
            return {
                ...state,
                getAllMasterCapitalTypeLogsResponse: { success: false, ...action.error }
            };
        case actionType.RESTORE_SETTINGS_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.RESTORE_SETTINGS_LOG_SUCCESS:
            return {
                ...state,
                restoreSettingsLogResponse: { success: true, ...action.response }
            };
        case actionType.RESTORE_SETTINGS_LOG_FAILURE:
            return {
                ...state,
                restoreSettingsLogResponse: { success: false, ...action.error }
            };

        case actionType.DELETE_SETTINGS_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_SETTINGS_LOG_SUCCESS:
            return {
                ...state,
                deleteSettingsLogResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_SETTINGS_LOG_FAILURE:
            return {
                ...state,
                deleteSettingsLogResponse: { success: false, ...action.error }
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_EXPORT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_EXPORT_SUCCESS:
            return {
                ...state,
                mastercapitaltypeExportResponse: { success: true, ...action.response }
            };
        case actionType.GET_MASTER_CAPITAL_TYPE_EXPORT_FAILURE:
            return {
                ...state,
                mastercapitaltypeExportResponse: { success: false, ...action.error }
            };   

        default:
            return state;
    }
};
